// extracted by mini-css-extract-plugin
module.exports = {"root":"_2wned","pageTitle":"_1CLPy","bottomTextWrapper":"_3u_e3","bottomTextSection":"IVB_u","section":"gaxE7"};